import styled from 'styled-components';

import { boxShadow1, green, lightGray } from 'utils/style/colors';

interface IInputContainerProps {
  focused: boolean;
}

interface IChipProps {
  selected: boolean;
}

export const Wrapper = styled('div')`
  position: relative;
`;

export const InputContainer = styled('div')<IInputContainerProps>`
  margin: 0.5rem 0;
  padding: 0.3rem;
  min-height: 35px;
  outline: none;
  transition: all 0.3s;
  border-width: 1px;
  border-style: solid;
  border-color: ${(props) => (props.focused ? green : 'var(--gray)')};
  box-shadow: ${(props) =>
    props.focused ? '0 0 0 2px rgba(50, 200, 182, 0.3)' : 'none'};
  border-radius: 10px;
  background-color: var(--exact-white);
  box-sizing: border-box;
  &:hover {
    border-color: ${green};
  }
`;

export const ChipsInput = styled('input')`
  background: none;
  border: 0;
  color: rgba(0, 0, 0, 0.6);
  display: inline-block;
  font-size: 1rem;
  height: 2rem;
  line-height: 2rem;
  outline: 0;
  margin: 0;
  padding: 0 !important;
  max-width: 12rem !important;
  margin: 3px;
`;

export const Chip = styled('span')<IChipProps>`
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 500;
  line-height: 2rem;
  padding: 0 0.5rem;
  border-radius: 10px;
  color: ${(props) =>
    props.selected ? 'var(--exact-white)' : 'rgba(0,0,0,0.6)'};
  background-color: ${(props) => (props.selected ? green : `${lightGray}`)};
  margin: 3px;
`;

export const RemoveIcon = styled('i')`
  cursor: pointer;
  float: right;
  font-size: 0.8rem;
  line-height: 2rem;
  padding-left: 0.5rem;
`;

export const ItemList = styled('ul')<IInputContainerProps>`
  display: ${(props) => (props.focused ? 'block' : 'none')};
  position: absolute;
  top: 100%;
  right: 0;
  max-height: 200px;
  width: 100%;
  background-color: var(--exact-white);
  box-shadow: ${boxShadow1};
  border-radius: 10px;
  overflow-y: auto;
  overflow-y: overlay;
  margin: 5px 0 0;
  z-index: 100;
`;

export const Item = styled('li')`
  padding: 0.5rem;
  &:hover {
    background-color: ${lightGray};
    cursor: pointer;
  }
`;
